import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.is-extensible";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import * as mixins from '~utils/mixins';
export var editor = function editor(theme) {
  return {
    p: 2,
    border: function border(t) {
      return "1px solid " + t.colors.border;
    },
    borderRadius: '0 0 4px 4px',
    background: theme.plain.backgroundColor,
    borderTop: 0,
    fontFamily: 'monospace',
    fontSize: 18,
    '* > textarea:focus': {
      outline: 'none'
    }
  };
};

if (typeof editor !== 'undefined' && editor && editor === Object(editor) && Object.isExtensible(editor) && !editor.hasOwnProperty('__filemeta')) {
  Object.defineProperty(editor, '__filemeta', {
    configurable: true,
    value: {
      name: "editor",
      filename: "node_modules/gatsby-theme-docz/src/components/Playground/styles.js"
    }
  });
}

export var error = {
  m: 0,
  py: 2,
  px: 3,
  bg: '#FF4757',
  fontSize: 1,
  color: 'white'
};

if (typeof error !== 'undefined' && error && error === Object(error) && Object.isExtensible(error) && !error.hasOwnProperty('__filemeta')) {
  Object.defineProperty(error, '__filemeta', {
    configurable: true,
    value: {
      name: "error",
      filename: "node_modules/gatsby-theme-docz/src/components/Playground/styles.js"
    }
  });
}

export var previewWrapper = {
  position: 'relative'
};

if (typeof previewWrapper !== 'undefined' && previewWrapper && previewWrapper === Object(previewWrapper) && Object.isExtensible(previewWrapper) && !previewWrapper.hasOwnProperty('__filemeta')) {
  Object.defineProperty(previewWrapper, '__filemeta', {
    configurable: true,
    value: {
      name: "previewWrapper",
      filename: "node_modules/gatsby-theme-docz/src/components/Playground/styles.js"
    }
  });
}

export var previewInner = function previewInner(showingCode, height) {
  if (height === void 0) {
    height = 'auto';
  }

  return {
    height: height,
    display: 'block',
    minHeight: '100%',
    width: 'calc(100% - 2px)',
    bg: 'playground.bg',
    border: function border(t) {
      return "1px solid " + t.colors.playground.border;
    },
    borderRadius: showingCode ? '4px 4px 0 0' : '4px'
  };
};

if (typeof previewInner !== 'undefined' && previewInner && previewInner === Object(previewInner) && Object.isExtensible(previewInner) && !previewInner.hasOwnProperty('__filemeta')) {
  Object.defineProperty(previewInner, '__filemeta', {
    configurable: true,
    value: {
      name: "previewInner",
      filename: "node_modules/gatsby-theme-docz/src/components/Playground/styles.js"
    }
  });
}

export var preview = {
  m: 0,
  p: '20px'
};

if (typeof preview !== 'undefined' && preview && preview === Object(preview) && Object.isExtensible(preview) && !preview.hasOwnProperty('__filemeta')) {
  Object.defineProperty(preview, '__filemeta', {
    configurable: true,
    value: {
      name: "preview",
      filename: "node_modules/gatsby-theme-docz/src/components/Playground/styles.js"
    }
  });
}

export var buttons = {
  zIndex: 9,
  display: 'flex',
  position: 'absolute',
  bottom: -20,
  right: 4
};

if (typeof buttons !== 'undefined' && buttons && buttons === Object(buttons) && Object.isExtensible(buttons) && !buttons.hasOwnProperty('__filemeta')) {
  Object.defineProperty(buttons, '__filemeta', {
    configurable: true,
    value: {
      name: "buttons",
      filename: "node_modules/gatsby-theme-docz/src/components/Playground/styles.js"
    }
  });
}

export var button = _objectSpread({}, mixins.ghostButton, {
  display: 'flex',
  alignItems: 'center',
  py: 1,
  p: 2,
  bg: 'border',
  color: 'muted',
  borderRadius: '0 0 3px 3px',
  '& ~ &': {
    ml: 1
  }
});

if (typeof button !== 'undefined' && button && button === Object(button) && Object.isExtensible(button) && !button.hasOwnProperty('__filemeta')) {
  Object.defineProperty(button, '__filemeta', {
    configurable: true,
    value: {
      name: "button",
      filename: "node_modules/gatsby-theme-docz/src/components/Playground/styles.js"
    }
  });
}

export var link = {
  py: 0,
  ml: 1,
  height: 22
};

if (typeof link !== 'undefined' && link && link === Object(link) && Object.isExtensible(link) && !link.hasOwnProperty('__filemeta')) {
  Object.defineProperty(link, '__filemeta', {
    configurable: true,
    value: {
      name: "link",
      filename: "node_modules/gatsby-theme-docz/src/components/Playground/styles.js"
    }
  });
}